import { Box, styled, Theme } from '@mui/material';

export const SpacerStyled = styled(Box)(
  ({
    theme,
    width,
    height,
  }: {
    theme: Theme;
    width: number;
    height: number;
  }) => ({
    width: width ? theme.spacing(width) : undefined,
    height: height ? theme.spacing(height) : undefined,
    flexGrow: 0,
    flexShrink: 0,
  })
) as typeof Box;
